import { Injectable } from '@angular/core';
import {Resolve, ActivatedRouteSnapshot} from '@angular/router';
//import { environment } from '../../environments/environment';

@Injectable()
export class ExternalService implements Resolve<any> {

resolve(route: ActivatedRouteSnapshot){
    window.open(route.paramMap.get('externalUrl'), '_self'); 
    return false;
  }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/external.service.ts